import React from 'react';
export class ChanelTitle extends React.Component {
  render() {
    const contentData = this.props.contentData,
      chanelNameFirst = contentData.chanelNameFirst,
      chanelNameSecond = contentData.chanelNameSecond,
      chanelNameThird = contentData.chanelNameThird;
    // A prop of h2='true' is being passed from the ChanelProductItemComponent component to avoid multiple <h1> tags on the the page.
    return React.createElement(
      this.props.h2 ? 'h2' : 'h1',
      { className: 'chanelTitle' },
      <span className='chanelTitle1'>{chanelNameFirst}</span>,
      <span className='chanelTitle2'>{chanelNameSecond}</span>,
      <span className='chanelTitle3'>{chanelNameThird}</span>
    );
    // Please note the return below is equivalnt to the React Create Element return above.
    // return (
    //     <Choose>
    //         <When test={this.props.asd}>
    //             <h2 className='chanelTitle'>
    //                 <span className='chanelTitle1'>{chanelNameFirst}</span>
    //                 <span className='chanelTitle2'>{chanelNameSecond}</span>
    //                 <span className='chanelTitle3'>{chanelNameThird}</span>
    //             </h2>
    //         </When>
    //         <Otherwise>
    //             <h1 className='chanelTitle'>
    //                 <span className='chanelTitle1'>{chanelNameFirst}</span>
    //                 <span className='chanelTitle2'>{chanelNameSecond}</span>
    //                 <span className='chanelTitle3'>{chanelNameThird}</span>
    //             </h1>
    //         </Otherwise>
    //     </Choose>
    // )
  }
}

export default ChanelTitle;
